"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/ArchiveCampaignModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);








/* Rev 20 J3: archiving a finished campaign asks first; a draft doesn't. */
const ArchiveCampaignModal = ({ isOpen, campaignName, onClose, onConfirm }) => (
  _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onClose: onClose, title: "Archive campaign" , size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}
    , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}, "Archive “" ,  campaignName , "”?")
    , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}, "It moves to the Archived tab, where you can still view it or unarchive it."

    )
    , _react2.default.createElement(_Modal.ModalControls, {
      primaryBtnLabel: "Archive campaign" ,
      onPrimaryBtnClick: onConfirm,
      secondaryBtnLabel: "Cancel",
      onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}}
    )
  )
)

exports. default = ArchiveCampaignModal
